// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page .sidebar[data-v-2b8c95e2]{grid-row:1/span 1;margin-top:1.5rem}@media (min-width: 768px){.page .sidebar[data-v-2b8c95e2]{margin-top:2.5rem}}.chip[data-v-2b8c95e2]{border-radius:4px;--tw-bg-opacity:1;background-color:rgb(242 245 249 / var(--tw-bg-opacity, 1));padding-top:0.375rem;padding-bottom:0.375rem;padding-left:0.75rem;padding-right:0.75rem;font-size:1.125rem;line-height:1.5rem;color:rgba(0,0,0,0.87)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
